import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { setAuthNavigate } from "../../utils/authRedirect";

/** Registers React Router navigate for axios auth redirects (used outside components). */
const AuthNavigateRegistrar = () => {
  const navigate = useNavigate();

  useEffect(() => {
    setAuthNavigate(navigate);
  }, [navigate]);

  return null;
};

export default AuthNavigateRegistrar;
